import React, { useState, useEffect } from 'react';

const CaseStudySlider = ({ images, onImageClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState(new Set([0])); // Preload first image

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex === images.length - 1 ? 0 : prevIndex + 1;
        // Preload next image
        setLoadedImages(prev => new Set([...prev, nextIndex]));
        return nextIndex;
      });
    }, 4000);

    return () => clearInterval(timer);
  }, [images.length]);

  // Preload adjacent images
  useEffect(() => {
    const nextIndex = (currentIndex + 1) % images.length;
    setLoadedImages(prev => new Set([...prev, currentIndex, nextIndex]));
  }, [currentIndex, images.length]);

  return (
    <div className="relative w-full overflow-hidden rounded-lg bg-gray-200" style={{ height: '400px' }}>
      <div 
        className="flex transition-transform duration-1000 ease-in-out"
        style={{ 
          transform: `translateX(-${currentIndex * 100}%)`,
          height: '400px'
        }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="flex-shrink-0 cursor-pointer relative"
            style={{ width: '100%', height: '400px' }}
            onClick={() => onImageClick(image)}
          >
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover"
              loading={loadedImages.has(index) ? 'eager' : 'lazy'}
              decoding="async"
            />
            {/* Hover overlay */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 hover:opacity-100 transition-opacity pointer-events-none">
              <div className="bg-white/90 rounded-full p-3">
                <svg className="w-8 h-8 text-[#aaae10]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              setCurrentIndex(index);
            }}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              index === currentIndex
                ? 'bg-[#aaae10] w-8'
                : 'bg-white/60 hover:bg-white'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CaseStudySlider;
